import React, {useState, useEffect} from 'react';
import styled from '@emotion/styled';

import {Link, useLocation} from 'react-router-dom';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: 14.75rem;
	height: 100vh;

	background: white;

	box-shadow: 4px 0 6px rgba(0, 0, 0, 0.04), 2px 0 4px rgba(0, 0, 0, 0.02);
`;

const Logo = styled.img`
	width: 5.75rem;
	height: 2.125rem;
	margin: 1rem 0 1rem 1.5rem;
`;

const MenuIcon = styled.img`
	width: 1rem;
	height: 1rem;

	margin: 0 1rem 0 1.5rem;
`;

const MenuOption = styled.div`
	display: flex;
	width: auto;
	height: 3rem;

	align-items: center;

	cursor: pointer;
	
	${props => props.selected && 'background: var(--color-gray-100)'};
	${props => props.selected && 'border-left: 4px solid var(--company)'};
`;

const MenuText = styled.h2`
	height: 1rem;
	font-size: 1rem;
	line-height: 1rem;

	font-style: normal;
	font-weight: 500;

	color: var(--color-gray-600);
`;

const NotificationAlert = styled.div`
	width: 0.5rem;
	height: 0.5rem;

	margin: auto;

	border-radius: 0.25rem;

	background: var(--company);
`;

const Divider = styled.div`
	width: 100%;
	height: 1px;
	background: var(--color-gray-300);
`;

const MenuBackground = styled.div`
	flex-grow: 1;
`;

function BackOfficeNavigationMenu() {

    const location = useLocation();

    return (
        <Container>
            <Link to="/backoffice/orders">
                <Logo alt="brand" src="/irad-logo.svg"/>
            </Link>
            <Divider/>
            <Link to="/backoffice/orders">
                <MenuOption selected={location.pathname.includes('orders')}>
                    <MenuIcon alt="orders" src="/icons/bag.svg"/>
                    <MenuText>Orders</MenuText>
                </MenuOption>
            </Link>
            <Divider/>
            <Link to="/backoffice/notifications">
                <MenuOption selected={location.pathname.includes('notifications')}>
                    <MenuIcon alt="notifications" src="/icons/notifications.svg" />
                    <MenuText>Notifications</MenuText>
                {/*	<NotificationAlert />*/}
                </MenuOption>
            </Link>
            <Divider />
            <Link to="/backoffice/products">
                <MenuOption selected={location.pathname.includes('products')}>
                    <MenuIcon alt="products" src="/icons/products.svg"/>
                    <MenuText>Products</MenuText>
                </MenuOption>
            </Link>
            <Divider />
            <Link to="/backoffice/reviews">
                <MenuOption selected={location.pathname.includes('reviews')}>
                    <MenuIcon alt="reviews" src="/icons/reviews.svg"/>
                    <MenuText>Reviews</MenuText>
                </MenuOption>
            </Link>
            <Divider/>
            <Link to="/backoffice/customers">
                <MenuOption selected={location.pathname.includes('customers')}>
                    <MenuIcon alt="customers" src="/icons/users.svg"/>
                    <MenuText>Customers</MenuText>
                </MenuOption>
            </Link>
            <Divider/>
            <Link to="/backoffice/offers">
                <MenuOption selected={location.pathname.includes('offers')}>
                    <MenuIcon alt="offers" src="/icons/offer.svg"/>
                    <MenuText>Offers</MenuText>
                </MenuOption>
            </Link>
            <Divider/>
            <Link to="/backoffice/announcements">
                <MenuOption selected={location.pathname.includes('announcements')}>
                    <MenuIcon alt="announcements" src="/icons/information.svg"/>
                    <MenuText>Announcements</MenuText>
                </MenuOption>
            </Link>
            <Divider/>
            {/*<MenuOption>*/}
            {/*	<MenuIcon alt="learning_centre" src="/icons/info.svg" />*/}
            {/*	<MenuText>Learning Centre</MenuText>*/}
            {/*</MenuOption>*/}
            {/*<Divider />*/}
            <MenuBackground>
                {/*<img src="/navigation_menu_bg.svg" />*/}
            </MenuBackground>
            <Divider/>
            <MenuOption>
                <MenuIcon alt="settings" src="/icons/settings.svg"/>
                <MenuText>Settings</MenuText>
            </MenuOption>
        </Container>
    );
}

export default BackOfficeNavigationMenu;
